import React, { Component } from 'react'
import Modal from '../UI/Modal'
import Loader from '../UI/Loader'
import CKEditor from '../UI/CKEditor'
import LangSelector from '../UI/LangSelector'
import M from 'materialize-css'
import Benefits from './Benefits'
import Workers from './Workers'
import Products from './Products'
import ServiceVente from './ServiceVente'
import ServicePrestation from './ServicePrestation'
import tools from '../../tools'
import '../Core/Main.css'
import OnlyPremium from '../UI/OnlyPremium'
import PremiumAlert from '../UI/PremiumAlert'
import EmptyFolder from '../UI/EmptyFolder'
import { HomeIcon } from '@heroicons/react/outline'
import { Link, Redirect } from 'react-router-dom'
import BannerInfo from '../UI/BannerInfo'
import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'

class Services extends Component {
	constructor(props) {
		super(props)
		this.state = this._initState()
		this.length_max = 50
		this.props.updateNavbarTitle('Services')
	}

	componentDidMount() {
		this.loadServices()
		this.loadTodayOrderCounts()
		this.loadStripeStatus()
	}

	// Le paramétrage du paiement in-app n'est proposé que si le compte Stripe du
	// camping est connecté et actif.
	loadStripeStatus = () => {
		this.props.fetchStripeStatus()
		.then(status => {
			const stripe_ready = (status && status.connected === true && status.charges_enabled === true)
			this.setState({ stripe_ready: stripe_ready })
		})
		.catch(err => {
			console.log(err)
		})
	}

	componentDidUpdate(prevProps, prevState) {
		const elems = document.querySelectorAll('select')
		M.FormSelect.init(elems)
		if (prevProps.services !== this.props.services)
			this.loadServices(true)
		if (prevProps.location.key !== this.props.location.key)
		{
			this.setState(this._initState())
			this.loadServices()
			this.loadStripeStatus()
		}
		if (this.state.init_dropdown === false)
		{
			const dropdowns = document.querySelectorAll('.dropdown-trigger')
			if (dropdowns.length > 0)
			{
				M.Dropdown.init(dropdowns)
				this.setState({ init_dropdown: true })
			}
		}
		if (this.state.init_modal === false)
		{
			const modals = document.querySelectorAll('.modal')
			if (modals.length > 0)
			{
				M.Modal.init(modals)
				this.setState({ init_modal: true })
			}
		}
		if (prevProps.service_benefits !== this.props.service_benefits && this.state.edit)
		{
			let service_benefits = []
			for (let i = 0; i < this.props.service_benefits.length; i++)
			{
				if (this.props.service_benefits[i].service === this.state.edit._id)
					service_benefits.push(this.props.service_benefits[i])
			}
			this.setState({ service_benefits: service_benefits })
		}
		if (prevProps.service_workers !== this.props.service_workers && this.state.edit)
		{
			let service_workers = []
			for (let i = 0; i < this.props.service_workers.length; i++)
			{
				if (this.props.service_workers[i].service === this.state.edit._id)
					service_workers.push(this.props.service_workers[i])
			}
			this.setState({ service_workers: service_workers })
		}
		if (prevProps.service_products !== this.props.service_products && this.state.edit)
		{
			let service_products = []
			for (let i = 0; i < this.props.service_products.length; i++)
			{
				if (this.props.service_products[i].service === this.state.edit._id)
					service_products.push(this.props.service_products[i])
			}
			this.setState({ service_products: service_products })
		}
	}

	loadIcons = () => {
		this.props.fetchIcons()
		.then(icons => {
			this.setState({ icons: icons })
		})
		.catch(err => {
			this.setErrorMsg("error_fetch_services", 1)
			console.log(err)
		})
	}

	loadTheme = () => {
		this.props.fetchTheme()
		.then(theme => {
			this.setState({ theme: theme })
		})
		.catch(err => {
			this.setErrorMsg("error_fetch_services", 2)
			console.log(err)
		})
	}

	loadServices = (fromProps = false) => {
		if (fromProps === true)
			this.setState({ services: this.props.services })
		else
		{
			this.props.fetchServices()
			.then(services => {
				this.setState({ services: services })
			})
			.catch(err => {
				this.setErrorMsg("error_fetch_services", 3)
				console.log(err)
			})
		}
	}

	loadServiceBenefits = (service) => {
		this.props.fetchServiceBenefitsByService(service)
		.then(service_benefits => {
			this.setState({ service_benefits: service_benefits })
		})
		.catch(err => {
			this.setErrorMsg("error_fetch_service_benefits", 1)
			console.log(err)
		})
	}

	loadServiceWorkers = (service) => {
		this.props.fetchServiceWorkersByService(service)
		.then(service_workers => {
			this.setState({ service_workers: service_workers })
		})
		.catch(err => {
			this.setErrorMsg("error_fetch_service_workers", 1)
			console.log(err)
		})
	}

	loadTodayOrderCounts = () => {
		if (!this.props.fetchReservationsByDateRange) return
		const now = new Date()
		const start = Math.floor(new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime() / 1000)
		const end = Math.floor(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime() / 1000)
		this.props.fetchReservationsByDateRange(start, end)
		.then(reservations => {
			const counts = {}
			let prestationTotal = 0
			for (let i = 0; i < reservations.length; i++) {
				const r = reservations[i]
				if (r.cancelled) continue
				const sid = String(typeof r.service === 'object' ? r.service._id : r.service)
				counts[sid] = (counts[sid] || 0) + 1
				if (!r.cart || r.cart.length === 0)
					prestationTotal++
			}
			this.setState({ todayOrderCounts: counts, todayPrestationInscriptions: prestationTotal })
		})
		.catch(() => {})
	}

	loadServiceProducts = (service) => {
		this.props.fetchServiceProductsByService(service)
		.then(service_products => {
			this.setState({ service_products: service_products })
		})
		.catch(err => {
			this.setErrorMsg("error_fetch_service_products", 1)
			console.log(err)
		})
	}

	_initState = () => {
		return {
			edit: null,
			create: false,
			click_modal: 0,
			attempt_submit: false,
			services: undefined,
			todayOrderCounts: {},
			todayPrestationInscriptions: 0,
			init_dropdown: false,
			init_modal: false,
			modal: null,
			edit_modal: false,
			answerModal: null,
			open_modal: false,
			modal_msg: null,
			delete: null,
			service_benefits: null,
			service_workers: null,
			stripe_ready: false,
			form1: {
				name: '',
				cover: null,
				type: '',
				translations: [],
				payment_link: '',
				payment_mode: null,
				comment: '',
				list_mode: false
			},
			pages: [
				{ name: 'Services', href: '/services', current: false }
			],
			show_banner: false,
			banner_content: null,
			current_lang: this.props.lang_default,
			error: this._initErrors(),
			success: this._initSuccess()
		}
	}

	_initSuccess = () => {
		const success = {
			global: null,
			benefits: null,
			workers: null
		}
		return success
	}

	_initErrors = () => {
		const errors = {
			global: null,
			service: null,
			name: null,
			title: null,
			cover: null,
			type: null,
			benefits: null,
			workers: null
		}
		return errors
	}

	setErrorMsg = (key, msg, id = null) => {
		if (key === "error_fetch_services")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de récupérer les services", msg)
		}
		else if (key === "error_create_service")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de créer un service", msg)
		}
		else if (key === "error_update_service")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de modifier un service", msg)
		}
		else if (key === "error_delete_service")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de supprimer un service", msg)
		}
		else if (key === "error_fetch_service_benefits")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de récupérer les prestations", msg)
		}
		else if (key === "error_delete_service_benefit")
		{
			key = "benefits"
			msg = tools.default_error_msg("Impossible de supprimer une prestation", msg)
		}
		else if (key === "error_fetch_service_workers")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de récupérer les prestataires", msg)
		}
		else if (key === "error_delete_service_worker")
		{
			key = "workers"
			msg = tools.default_error_msg("Impossible de supprimer un prestataire", msg)
		}
		else if (key === "error_fetch_service_procucts")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de récupérer les produits", msg)
		}
		else if (key === "error_delete_service_product")
		{
			key = "products"
			msg = tools.default_error_msg("Impossible de supprimer un produit", msg)
		}
		let error = this._initErrors()
		if (id !== null)
			error[key][id] = msg
		else
			error[key] = msg
		this.setState({ success: this._initSuccess(), error: error, show_banner: true, banner_content: msg })
	}

	setSuccessMsg = (key, msg) => {
		const error = this._initErrors()
		let success = this.state.success
		success[key] = msg
		this.setState({ success: success, error: error, show_banner: true, banner_content: msg })
	}

	clearFlash = () => {
		const error = this._initErrors()
		const success = this._initSuccess()
		this.setState({ error: error, success: success })
	}

	closeBanner = () => {
		this.setState({ show_banner: false })
	}

	classNames = (...classes) => {
		return classes.filter(Boolean).join(' ')
	}

	clickEdit = (id) => {
		let service = null
		let form1 = {
			name: '',
			cover: null,
			type: '',
			translations: [],
			payment_link: '',
			payment_mode: null,
			comment: '',
			list_mode: false
		}
		let pages = [...this.state.pages]
		for (let i = 0; i < this.state.services.length; i++)
		{
			if (this.state.services[i]._id === id)
			{
				service = this.state.services[i]
				form1 = {
					name: service.name,
					cover: service.cover,
					type: service.type,
					translations: service.translations,
					comment: service.comment,
					list_mode: service.list_mode,
					payment_link: service.payment_link,
					payment_mode: (service.payment_mode != null) ? service.payment_mode : null
				}
				break
			}
		}
		for (let i = 0; i < pages.length; i++)
			pages[i].current = false
		pages.push({ name: form1.name, href: null, current: true })
		if (service.type === "prestation")
		{
			this.loadServiceBenefits(id)
			this.loadServiceWorkers(id)
		}
		else if (service.type === "vente")
			this.loadServiceProducts(id)
		this.clearFlash()
		this.setState({ edit: service, form1: form1, create: false, attempt_submit: false, init_modal: false, pages: pages })
	}

	clickDelete = (id) => {
		this.clearFlash()
		const modal_msg = "Vous êtes sur le point du supprimer cette prestation. Cette action est irréversible"
		this.setState({ delete: id, open_modal: true, modal_msg: modal_msg, answerModal: this.answerModalDelete })
	}

	clickDeleteService = () => {
		this.clearFlash()
		const modal_msg = "Vous êtes sur le point du supprimer ce service. Cette action est irréversible"
		this.setState({ delete: true, open_modal: true, modal_msg: modal_msg, answerModal: this.answerModalDelete })
	}
	
	clickCreate = () => {
		const form1 = {
			name: '',
			type: '',
			cover: null,
			translations: [],
			payment_link: '',
			payment_mode: null,
			comment: '',
			list_mode: false
		}
		this.clearFlash()
		this.setState({ edit: null, form1: form1, create: true, attempt_submit: false, init_modal: false })
	}

	handleName = (event) => {
		const form1 = {
			...this.state.form1,
			name: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handleTitle = (event) => {
		let found = false
		const translations = this.state.form1.translations
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === this.state.current_lang)
			{
				found = true
				translations[i].title = event.target.value
				break
			}
		}
		if (!found)
		{
			translations.push({
				lang: this.state.current_lang,
				title: event.target.value
			})
		}
		const form1 = {
			...this.state.form1,
			translations: translations
		}
		this.setState({ form1: form1 })
	}

	handleListMode = (event) => {
		const form1 = {
			...this.state.form1,
			list_mode: (this.state.form1.list_mode === true) ? false : true,
		}
		this.setState({ form1: form1 })
	}

	handleCover = (event) => {
		const reader = new FileReader()
		const file = event.target.files[0]
		reader.addEventListener("load", () => {
			const form1 = {
				...this.state.form1,
				cover: reader.result
			}
			this.setState({ form1: form1 })
		}, false)
		if (file)
			reader.readAsDataURL(file)
	}

	handleType = (type) => {
		let options = {}
		if (type === "prestation")
		{
			options = {
				limit: true,
				simultaneous: 1
			}
		}
		const form1 = {
			...this.state.form1,
			type: type,
			options: options
		}
		this.setState({ form1: form1 })
	}

	handleComment = (html) => {
		const form1 = {
			...this.state.form1,
			comment: html
		}
		this.setState({ form1: form1 })
	}

	_validateForm1 = () => {
		let error_obj = this._initErrors()
		const name = this.state.form1.name
		const payment_link = this.state.form1.payment_link
		const type = this.state.form1.type
		const cover = this.state.form1.cover
		const translations = this.state.form1.translations
		let error = false
		if (name.length === 0)
		{
			error = true
			error_obj.name = "Le nom ne doit être vide"
		}
		else if (name.length > this.length_max)
		{
			error = true
			error_obj.name = "Le nom ne doit pas dépasser " + this.length_max + " caractères"
		}
		if (payment_link.length > 0 && !tools.isValidUrl(payment_link))
		{
			error = true
			error_obj.payment_link = "Le lien de paiement n'est pas valide"
		}
		if (cover === null)
		{
			error = true
			error_obj.cover = "Vous devez sélectionner une photo de couverture"
		}
		if (type.length === 0)
		{
			error = true
			error_obj.type = "Vous devez choisir un type"
		}
		else if (type !== "location" && type !== "prestation" && type !== "vente")
		{
			error = true
			error_obj.type = "Type invalide"
		}
		let found_default_title = false
		for (let i = 0; i < translations.length; i++)
		{
			const lang = translations[i].lang
			const title = translations[i].title
			if (title.length === 0 && lang === this.props.lang_default)
			{
				error = true
				error_obj.title = "Le titre ne doit pas être vide (version " + lang.toUpperCase() + ")"
			}
			else if (title.length > this.length_max)
			{
				error = true
				error_obj.title = "Le titre ne doit pas dépasser " + this.length_max + " caractères (version " + lang.toUpperCase() + ")"
			}
			else if (lang === this.props.lang_default)
				found_default_title = true
		}
		if (!found_default_title && !error_obj.title)
		{
			error = true
			error_obj.title = 'Le titre ne doit pas être vide (version ' + this.props.lang_default.toUpperCase() + ')'
		}
		if (error === true)
		{
			const success = this._initSuccess()
			error_obj.service = "Il y a une ou plusieurs erreur(s) dans le formulaire"
			this.setState({ success: success, error: error_obj, attempt_submit: false })
		}
		return (!error) ? true : false
	}

	handlePaymentLink = (event) => {
		const form1 = {
			...this.state.form1,
			payment_link: event.target.value
		}
		this.setState({ form1: form1 })
	}

	handlePaymentMode = (mode) => {
		const form1 = {
			...this.state.form1,
			payment_mode: mode
		}
		this.setState({ form1: form1 })
	}

	handleSubmit = (event) => {
		this.setState({ attempt_submit: true })
		event.preventDefault()
		if (this._validateForm1())
		{
			const translations = this.state.form1.translations
			let langs_not_found = []
			for (let i = 0; i < this.props.langs.length; i++)
			{
				let found = false
				for (let j = 0; j < translations.length; j++)
				{
					if (this.props.langs[i] === translations[j].lang && translations[j].title.length > 0)
					{
						found = true
						break
					}
				}
				if (!found)
					langs_not_found.push(this.props.langs[i])
			}
			if (langs_not_found.length > 0)
			{
				let msg = ""
				for (let i = 0; i < langs_not_found.length; i++)
				{
					if (i > 0)
						msg += ', '
					msg += langs_not_found[i].toUpperCase()
				}
				msg = "Le service n'est pas traduit dans les langues suivantes : " + msg
				this.setState({ modal_msg: msg, open_modal: true, answerModal: this.answerModalEdit })
			}
			else
				this._insertService()
		}
	}

	_insertService = () => {
		const service = {
			name: this.state.form1.name,
			cover: this.state.form1.cover,
			type: this.state.form1.type,
			translations: this.state.form1.translations,
			comment: (this.state.form1.comment !== "") ? this.state.form1.comment : null,
			payment_link: this.state.form1.payment_link,
			payment_mode: this.state.form1.payment_mode,
			list_mode: this.state.form1.list_mode,
			user: this.props.user._id
		}
		if (this.state.create === true)
		{
			this.props.insertService(service)
			.then(ret => {
				this.setSuccessMsg('global', "Le service a bien été créé")
				this.setState({ create: false, edit: ret, init_dropdown: false, attempt_submit: false, open_modal: false })
			})
			.catch(err => {
				this.setState({ attempt_submit: false, open_modal: false })
				this.setErrorMsg("error_create_service", 1)
				console.log(err)
			})
		}
		else if (this.state.edit !== null)
		{
			service._id = this.state.edit._id
			if (this.state.edit.type !== service.type) // Changement de type de service
			{
				if (this.state.edit.type === 'prestation')
				{
					this.props.deleteServiceBenefitsByService(this.state.edit._id)
					.then(ret => {
						if (ret === true)
						{
							this.props.deleteServiceWorkersByService(this.state.edit._id)
							.then(ret => {
								if (ret === true)
								{
									this.props.updateService(service)
									.then(ret => {
										this.setSuccessMsg('global', "Le service a bien été modifié")
										this.setState({ edit: ret, attempt_submit: false, open_modal: false })
									})
									.catch(err => {
										this.setState({ attempt_submit: false, open_modal: false })
										this.setErrorMsg("error_update_service", 1)
										console.log(err)
									})
								}
								else
								{
									this.setState({ attempt_submit: false, open_modal: false })
									this.setErrorMsg("error_update_service", 2)
								}
							})
						}
						else
						{
							this.setState({ attempt_submit: false, open_modal: false })
							this.setErrorMsg("error_update_service", 3)
						}
					})
					.catch(err => {
						this.setState({ attempt_submit: false, open_modal: false })
						this.setErrorMsg("error_update_service", 4)
						console.log(err)
					})
				}
				else if (this.state.edit.type === 'location')
				{
					/*
					TODO
					*/
				}
			}
			else
			{
				this.props.updateService(service)
				.then(ret => {
					this.setSuccessMsg('global', "Le service a bien été modifié")
					this.setState({ edit: ret, attempt_submit: false, open_modal: false })
				})
				.catch(err => {
					this.setState({ attempt_submit: false, open_modal: false })
					this.setErrorMsg("error_update_service", 5)
					console.log(err)
				})
			}
		}
	}

	_deleteService = () => {
		let id, type
		if (this.state.edit !== null) {
			id = this.state.edit._id
			type = this.state.edit.type
		} else if (this.state.delete && this.state.delete !== true) {
			id = this.state.delete
			const found = (this.state.services || []).find(s => s._id === id)
			type = found ? found.type : null
		}
		if (id && type)
		{
			if (type === "prestation")
			{
				this.props.deleteServiceBenefitsByService(id)
				.then(ret => {
					if (ret === true)
					{
						this.props.deleteServiceWorkersByService(id)
						.then(ret => {
							if (ret === true)
							{
								this.props.deleteServiceReservationsByService(id)
								.then(ret => {
									if (ret === true)
									{
										this.props.deleteService(id)
										.then(ret => {
											if (ret === true)
											{
												this.setSuccessMsg('global', "Le service a bien été supprimé")
												this.setState({ create: false, edit: null, delete: null, init_dropdown: false })
											}
											else
												this.setErrorMsg("error_delete_service", 3)
										})
										.catch(err => {
											this.setErrorMsg("error_delete_service", 4)
											console.log(err)
										})
									}
									else
										this.setErrorMsg("error_delete_service", 5)
								})
							}
							else
								this.setErrorMsg("error_delete_service", 9)
						})
					}
					else
						this.setErrorMsg("error_delete_service", 6)
				})
				.catch(err => {
					this.setErrorMsg("error_delete_service", 7)
					console.log(err)
				})
			}
			else if (type === "vente")
			{
				this.props.deleteServiceReservationsByService(id)
				.then(ret => {
					if (ret === true)
					{
						this.props.deleteService(id)
						.then(ret => {
							if (ret === true)
							{
								this.setSuccessMsg('global', "Le service a bien été supprimé")
								this.setState({ create: false, edit: null, delete: null, init_dropdown: false })
							}
							else
								this.setErrorMsg("error_delete_service", 8)
						})
						.catch(err => {
							this.setErrorMsg("error_delete_service", 10)
							console.log(err)
						})
					}
					else
						this.setErrorMsg("error_delete_service", 11)
				})
				.catch(err => {
					this.setErrorMsg("error_delete_service", 9)
					console.log(err)
				})
			}
			else if (type === "location")
			{
				/*
				TODO
				*/
			}
		}
	}

	createModal = (type) => {
		const modals = document.querySelectorAll('.modal')
		const instance = M.Modal.getInstance(modals[1])
		instance.open()
		this.clearFlash()
		const click_modal = this.state.click_modal + 1
		this.setState({ click_modal: click_modal, modal: type, edit_modal: false })
	}

	editModal = (type, id) => {
		let object = false
		let list = null
		if (type === 'benefit')
			list = this.state.service_benefits
		else if (type === 'worker')
			list = this.state.service_workers
		else if (type === "product")
			list = this.state.service_products
		if (list !== null)
		{
			for (let i = 0; i < list.length; i++)
			{
				if (list[i]._id === id)
				{
					object = list[i]
					break
				}
			}
			if (object)
			{
				const modals = document.querySelectorAll('.modal')
				const instance = M.Modal.getInstance(modals[1])
				instance.open()
				this.clearFlash()
				const click_modal = this.state.click_modal + 1
				this.setState({ click_modal: click_modal, modal: type, edit_modal: object })
			}
		}
	}

	deleteObject = (type, id) => {
		this.clearFlash()
		if (type === 'benefit')
		{
			const modal_msg = "Vous êtes sur le point du supprimer cette prestation. Cette action est irréversible"
			this.setState({ delete: { type: type, id: id }, open_modal: true, modal_msg: modal_msg, answerModal: this.answerModalDeleteObject })
		}
		else if (type === 'worker')
		{
			const modal_msg = "Vous êtes sur le point du supprimer ce prestataire. Cette action est irréversible"
			this.setState({ delete: { type: type, id: id }, open_modal: true, modal_msg: modal_msg, answerModal: this.answerModalDeleteObject })
		}
		else if (type === 'product')
		{
			const modal_msg = "Vous êtes sur le point du supprimer ce produit. Cette action est irréversible"
			this.setState({ delete: { type: type, id: id }, open_modal: true, modal_msg: modal_msg, answerModal: this.answerModalDeleteObject })
		}
	}

	_deleteObject = () => {
		const type = this.state.delete.type
		const id = this.state.delete.id
		if (type === 'benefit')
		{
			this.props.deleteServiceBenefit(id)
			.then(ret => {
				if (ret === true)
				{
					this.setState({ open_modal: false })
					this.setSuccessMsg('benefits', "La prestation a bien été supprimée")
				}
				else
				{
					this.setState({ open_modal: false })
					this.setErrorMsg("error_delete_service_benefit", 1)
				}
			})
			.catch(err => {
				this.setState({ open_modal: false })
				this.setErrorMsg("error_delete_service_benefit", 2)
				console.log(err)
			})
		}
		else if (type === 'worker')
		{
			this.props.deleteServiceWorker(id)
			.then(ret => {
				if (ret === true)
				{
					this.setState({ open_modal: false })
					this.setSuccessMsg('workers', "Le prestataire a bien été supprimé")
				}
				else
				{
					this.setState({ open_modal: false })
					this.setErrorMsg("error_delete_service_worker", 1)
				}
			})
			.catch(err => {
				this.setState({ open_modal: false })
				this.setErrorMsg("error_delete_service_worker", 2)
				console.log(err)
			})
		}
		else if (type === 'product')
		{
			this.props.deleteServiceProduct(id)
			.then(ret => {
				if (ret === true)
				{
					this.setState({ open_modal: false })
					this.setSuccessMsg('products', "Le produit a bien été supprimé")
				}
				else
				{
					this.setState({ open_modal: false })
					this.setErrorMsg("error_delete_service_product", 1)
				}
			})
			.catch(err => {
				this.setState({ open_modal: false })
				this.setErrorMsg("error_delete_service_product", 2)
				console.log(err)
			})
		}
	}

	closeModal = (key = null, msg = null) => {
		const modals = document.querySelectorAll('.modal')
		const instance = M.Modal.getInstance(modals[1])
		instance.close()
		if (key && msg)
			this.setSuccessMsg(key, msg)
	}

	answerModalEdit = (answer) => {
		if (answer === "yes")
			this._insertService()
		else
			this.setState({ attempt_submit: false, open_modal: false })
	}

	answerModalDelete = (answer) => {
		if (answer === "yes")
			this._deleteService()
		else
			this.setState({ delete: false, open_modal: false })
	}

	answerModalDeleteObject = (answer) => {
		if (answer === "yes")
			this._deleteObject()
		else
			this.setState({ delete: false, open_modal: false })
	}

	updateModal = (msg, open_modal, answerModal) => {
		this.setState({ modal_msg: msg, open_modal: open_modal, answerModal: answerModal })
	}

	updateLang = (lang) => {
		this.setState({ current_lang: lang })
	}

	_renderQuickActions = (prestationCount, venteCount) => {
		return (
			<div className="grid grid-cols-2 gap-4 mb-10">
				<button
					onClick={() => this.props.history.push('/services/booking')}
					className="bg-white border border-gray-200 rounded-2xl p-6 text-left hover:shadow-md hover:border-indigo-200 transition-all focus:outline-none"
				>
					<p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">Planning réservations</p>
					<p className="text-5xl font-bold text-gray-900 mb-1">{prestationCount}</p>
					<p className="text-sm text-gray-500 mb-6">inscription{prestationCount !== 1 ? 's' : ''} aujourd'hui</p>
					<p className="text-sm font-medium text-indigo-600">Voir le planning →</p>
				</button>
				<button
					onClick={() => this.props.history.push('/services/commandes')}
					className="bg-white border border-gray-200 rounded-2xl p-6 text-left hover:shadow-md hover:border-indigo-200 transition-all focus:outline-none"
				>
					<p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">Commandes du jour</p>
					<p className="text-5xl font-bold text-gray-900 mb-1">{venteCount}</p>
					<p className="text-sm text-gray-500 mb-6">commande{venteCount !== 1 ? 's' : ''} aujourd'hui</p>
					<p className="text-sm font-medium text-indigo-600">Voir les commandes →</p>
				</button>
			</div>
		)
	}

	render() {
		let content = null
		const navStyle = "flex bg-transparent shadow-none mb-10 px-4 sm:px-6 lg:px-8"
		const empty_folder_content = "Pour créer un service ou une activité sur réservation, cliquez sur le bouton \"Créer un service\"."
		const permissions = this.props.user.permissions
		if (!permissions || !permissions.services || permissions.services === 0)
			return (<Redirect to="/" />)
		else if (this.state.services === undefined)
		{
			content = (
				<div className="loader">
					<Loader />
				</div>
			)
		}
		else if (this.props.features !== "premium")
		{
			content = (
				<div>
					<OnlyPremium 
						title="Mes services"
						subtitle="Paramétrez des évènements sur inscription (ex : location de vélo, club enfant, dépot de pain...)"
						button="Créer un service"
						emptyFolder="Commencez par créer un service"
						emptyFolderSubtitle="Pas de services"
						navName="Services"
						navPath="/Services"
					/>
					<div className="mt-10">
						<PremiumAlert
							content="Mettez votre abonnement à niveau avec la formule premium pour accéder aux services !"
							button_text="En savoir plus !"
						/>
					</div>
				</div>
			)
		}
		else if (this.state.create === false && !this.state.edit)
		{
			const services = this.state.services || []
			const todayOrderCounts = this.state.todayOrderCounts || {}
			const prestation_services = services.filter(s => s.type === 'prestation')
			const vente_services = services.filter(s => s.type === 'vente')
			const totalVenteOrders = vente_services.reduce((sum, s) => sum + (todayOrderCounts[String(s._id)] || 0), 0)

			const renderServiceCard = (service) => {
				const { _id, name, cover, type } = service
				const isVente = type === 'vente'
				const orderCount = todayOrderCounts[_id] || 0
				const menuItems = [
					{ name: 'Paramètres', func: () => this.props.history.push('/services/' + _id) },
					{ name: 'Supprimer', func: this.clickDelete.bind(this, _id) },
				]
				return (
					<div key={_id} className="bg-white rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col">
						<div
							className="h-32 bg-gray-50 flex items-center justify-center overflow-hidden cursor-pointer bg-cover bg-center rounded-t-2xl"
							style={cover ? { backgroundImage: `url(${cover})` } : {}}
							onClick={() => this.props.history.push('/services/' + _id)}
						>
							{!cover && <span className="text-4xl">{isVente ? '🛒' : '🎯'}</span>}
						</div>
						<div className="p-4 flex flex-col flex-1">
							<div className="flex items-start justify-between gap-2 mb-2">
								<div
									className="text-sm font-semibold text-gray-900 leading-tight cursor-pointer hover:text-indigo-600 transition-colors"
									onClick={() => this.props.history.push('/services/' + _id)}
								>
									{name}
								</div>
								<Menu as="div" className="relative flex-shrink-0">
									<Menu.Button className="inline-flex items-center rounded-md border border-gray-200 bg-white px-2 py-1 text-xs text-gray-400 hover:bg-gray-50 focus:outline-none">
										···
									</Menu.Button>
									<Transition
										as={Fragment}
										enter="transition ease-out duration-100"
										enterFrom="transform opacity-0 scale-95"
										enterTo="transform opacity-100 scale-100"
										leave="transition ease-in duration-75"
										leaveFrom="transform opacity-100 scale-100"
										leaveTo="transform opacity-0 scale-95"
									>
										<Menu.Items className="absolute right-0 z-10 mt-1 w-40 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
											<div className="py-1">
												{menuItems.map((item) => (
													<Menu.Item key={item.name}>
														{({ active }) => (
															<button
																onClick={item.func}
																className={this.classNames(
																	active ? 'bg-gray-50 text-gray-900' : 'text-gray-700',
																	'block px-4 py-2 text-sm w-full text-left'
																)}
															>
																{item.name}
															</button>
														)}
													</Menu.Item>
												))}
											</div>
										</Menu.Items>
									</Transition>
								</Menu>
							</div>
							<div className="mt-auto pt-2 border-t border-gray-100">
								<div className="flex items-center gap-2">
									<span className={`w-2 h-2 rounded-full flex-shrink-0 ${orderCount > 0 ? 'bg-green-400' : 'bg-gray-300'}`}></span>
									<span className="text-xs text-gray-500">
										{orderCount > 0
											? `${orderCount} ${isVente ? 'commande' : 'inscription'}${orderCount > 1 ? 's' : ''} aujourd'hui`
											: (isVente ? 'Aucune commande aujourd\'hui' : 'Aucune inscription aujourd\'hui')}
										</span>
								</div>
							</div>
						</div>
					</div>
				)
			}

			content = (
				<>
					<div className="flex flex-col px-4 sm:px-6 lg:px-8">
						<div className="mb-5" aria-label="Breadcrumb">
							<ol className="flex items-center gap-1 text-sm">
								<li className="flex items-center">
									<Link to="/" className="text-gray-400 hover:text-gray-600 transition-colors">
										<HomeIcon className="flex-shrink-0 h-4 w-4" aria-hidden="true" />
										<span className="sr-only">Accueil</span>
									</Link>
								</li>
								{this.state.pages.map((page, id) => (
									<li key={id} className="flex items-center">
										<span className="text-gray-300 mx-1 select-none">/</span>
										<Link to={page.href} className="text-gray-400 hover:text-gray-600 transition-colors" aria-current={page.current ? 'page' : undefined}>
											{page.name}
										</Link>
									</li>
								))}
							</ol>
						</div>
						<div className="flex items-end justify-between mb-8">
							<div>
								<h1 style={{ fontFamily: "'Fraunces', Georgia, serif", letterSpacing: '-0.02em' }} className="text-4xl font-bold text-gray-900 leading-none mb-0">
									Mes services
								</h1>
								<p className="text-sm text-gray-400 mt-2 mb-0">
									Activités, événements et boutique de votre camping
								</p>
							</div>
							<Link to="/services/new" className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none">
								+ Créer un service
							</Link>
						</div>
						{this._renderQuickActions(this.state.todayPrestationInscriptions, totalVenteOrders)}
						{!services.length && (
							<EmptyFolder
								emptyFolderSubtitle="Pas de service paramétré"
								content={empty_folder_content}
							/>
						)}
						{prestation_services.length > 0 && (
							<div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 mb-10">
								<p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">
									Activités &amp; événements · {prestation_services.length} service{prestation_services.length > 1 ? 's' : ''}
								</p>
								<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
									{prestation_services.map(renderServiceCard)}
								</div>
							</div>
						)}
						{vente_services.length > 0 && (
							<div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 mb-10">
								<p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">
									Commandes &amp; boutique · {vente_services.length} service{vente_services.length > 1 ? 's' : ''}
								</p>
								<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
									{vente_services.map(renderServiceCard)}
								</div>
							</div>
						)}
					</div>
				</>
			)
		}
		else if (this.state.create === true || this.state.edit !== null)
		{
			const prestation = (this.state.form1.type === "prestation") ? true : false
			// const location = (this.state.form1.type === "location") ? true : false
			const vente = (this.state.form1.type === "vente") ? true : false
			let sendbtn = (<button type="submit" className="waves-effect waves-light btn">Enregistrer</button>)
			if (this.state.attempt_submit === true)
			{
				sendbtn = (
					<div className="center">
						<Loader />
					</div>
				)
			}
			let detailsJSX = null
			let modalJSX = null
			if (this.state.edit !== null && this.state.edit.type === "prestation")
			{
				detailsJSX = (
					<ServicePrestation
						updateLang={this.updateLang}
						langs={this.props.langs}
						lang_default={this.props.lang_default}
						service={this.state.edit}
						service_benefits={this.state.service_benefits}
						service_workers={this.state.service_workers}
						fetchServices={this.props.fetchServices}
						createModal={this.createModal}
						editModal={this.editModal}
						deleteObject={this.deleteObject}
						current_lang={this.state.current_lang}
						updateNavbarTitle={this.props.updateNavbarTitle}
					/>
				)
				if (this.state.modal === 'benefit')
				{
					modalJSX = (
						<Benefits
							current_lang={this.state.current_lang}
							langs={this.props.langs}
							lang_default={this.props.lang_default}
							updateLang={this.updateLang}
							closeModal={this.closeModal}
							edit_modal={this.state.edit_modal}
							service={this.state.edit}
							service_benefits={this.state.service_benefits}
							user={this.props.user}
							insertServiceBenefit={this.props.insertServiceBenefit}
							updateServiceBenefit={this.props.updateServiceBenefit}
							fetchIcons={this.props.fetchIcons}
							fetchTheme={this.props.fetchTheme}
							updateModal={this.updateModal}
							click_modal={this.state.click_modal}
						/>
					)
				}
				else if (this.state.modal === 'worker')
				{
					modalJSX = (
						<Workers
							closeModal={this.closeModal}
							edit_modal={this.state.edit_modal}
							lang_default={this.props.lang_default}
							service={this.state.edit}
							service_benefits={this.props.service_benefits}
							user={this.props.user}
							insertServiceWorker={this.props.insertServiceWorker}
							updateServiceWorker={this.props.updateServiceWorker}
							click_modal={this.state.click_modal}
						/>
					)
				}
			}
			else if (this.state.edit !== null && this.state.edit.type === "vente") // détail des paramétrages pour le service "vente"
			{
				detailsJSX = (
					<ServiceVente
						updateLang={this.updateLang}
						langs={this.props.langs}
						lang_default={this.props.lang_default}
						service={this.state.edit}
						service_products={this.state.service_products}
						fetchServices={this.props.fetchServices}
						createModal={this.createModal}
						editModal={this.editModal}
						deleteObject={this.deleteObject}
						updateServiceDuration={this.props.updateServiceDuration}
						current_lang={this.state.current_lang}
						updateNavbarTitle={this.props.updateNavbarTitle}
					/>
				)
				if (this.state.modal === 'product') // paramétrage des produits en vente
				{
					modalJSX = (
						<Products
							current_lang={this.state.current_lang}
							langs={this.props.langs}
							lang_default={this.props.lang_default}
							updateLang={this.updateLang}
							closeModal={this.closeModal}
							edit_modal={this.state.edit_modal}
							service={this.state.edit}
							service_products={this.state.service_products}
							user={this.props.user}
							insertServiceProduct={this.props.insertServiceProduct}
							updateServiceProduct={this.props.updateServiceProduct}
							fetchIcons={this.props.fetchIcons}
							fetchTheme={this.props.fetchTheme}
							updateModal={this.updateModal}
							click_modal={this.state.click_modal}
						/>
					)
				}
			}
			let title = ""
			for (let i = 0; i < this.state.form1.translations.length; i++)
			{
				if (this.state.form1.translations[i].lang === this.state.current_lang)
				{
					title = this.state.form1.translations[i].title
					break
				}
			}
			let prev = null
			if (this.state.form1.cover !== null)
				prev = (<div><p>Prévisualisation :</p><p><img src={this.state.form1.cover} className="prev" alt="Prévisualisation" /></p></div>)
			let deletebtn = null
			if (this.state.edit !== null)
				deletebtn = (<button type="button" onClick={this.clickDeleteService} className="waves-effect waves-light btn red">Supprimer le service</button>)
			content = (
				<div className="wrapper-content">
					<nav className={navStyle} aria-label="Breadcrumb">
						<ol className="bg-white rounded-md shadow px-6 flex space-x-4">
							<li className="flex">
								<div className="flex items-center">
									<Link to="/" className="text-gray-400 hover:text-gray-500">
										<HomeIcon className="flex-shrink-0 h-5 w-5" aria-hidden="true" />
										<span className="sr-only">Home</span>
									</Link>
								</div>
							</li>
							{this.state.pages.map((page, id) => {
								let linkJSX = (
									<div
										className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
									>
										{page.name}
									</div>
								)
								if (page.href)
								{
									linkJSX = (
										<Link
											to={page.href}
											className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
											aria-current={page.current ? 'page' : undefined}
										>
											{page.name}
										</Link>
									)
								}
								return (
									<li key={id} className="flex">
										<div className="flex items-center">
											<svg
												className="flex-shrink-0 w-6 h-full text-gray-200"
												viewBox="0 0 24 44"
												preserveAspectRatio="none"
												fill="currentColor"
												xmlns="http://www.w3.org/2000/svg"
												aria-hidden="true"
											>
												<path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
											</svg>
											{linkJSX}
										</div>
									</li>
								)
							})}
						</ol>
					</nav>
					<div id="modal2" className="modal">
						<div className="modal-content">
							{modalJSX}
						</div>
						<div className="modal-footer">
							<button onClick={this.closeModal} className="link waves-effect waves-green btn-flat">Fermer</button>
						</div>
					</div>
					<div className="row">
						<div className="module col s12">
							{/* <p className="center error">{this.state.error.global}</p>
							<p className="center success">{this.state.success.global}</p> */}
							<LangSelector lang={this.state.current_lang} updateLang={this.updateLang} />
							<form className="module-form" onSubmit={this.handleSubmit}>
								<label>
									<p className="error">{this.state.error.name}</p>
									<p>Nom :</p>
									<input type="text" value={this.state.form1.name} onChange={this.handleName} />
								</label>
								<label>
									<p className="error">{this.state.error.title}</p>
									<p>Titre (version {this.state.current_lang.toUpperCase()}) :</p>
									<input type="text" value={title} onChange={this.handleTitle} />
								</label>
								<label>
									<p>Commentaire :</p>
								</label>
								<CKEditor
									data={this.state.form1.comment}
									updateContent={this.handleComment}
								/>
								<p className="error">{this.state.error.type}</p>
								<p>Type :</p>
								<label>
									<input type="radio" className="with-gap" name="type" value="prestation" checked={prestation} onChange={this.handleType.bind(this, "prestation")} /> <span>Prestation</span>
								</label>
								{/* <label>
									<input type="radio" className="with-gap" name="type" value="location" checked={location} onChange={this.handleType.bind(this, "location")} /> <span>Location</span>
								</label> */}
								<label>
									<input type="radio" className="with-gap" name="type" value="vente" checked={vente} onChange={this.handleType.bind(this, "vente")} /> <span>Vente</span>
								</label>
								<label>
									<p className="error">{this.state.error.payment_link}</p>
									<p>Lien de paiement :</p>
									<input type="text" value={this.state.form1.payment_link} onChange={this.handlePaymentLink} />
								</label>
								{this.state.stripe_ready && (
									<React.Fragment>
										<p>Paiement CB in-app :</p>
										<label>
											<input type="radio" className="with-gap" name="payment_mode" checked={this.state.form1.payment_mode == null} onChange={this.handlePaymentMode.bind(this, null)} /> <span>Désactivé (paiement géré sur place)</span>
										</label>
										<label>
											<input type="radio" className="with-gap" name="payment_mode" checked={this.state.form1.payment_mode === "cb_optional"} onChange={this.handlePaymentMode.bind(this, "cb_optional")} /> <span>Au choix du vacancier (CB in-app ou sur place)</span>
										</label>
										<label>
											<input type="radio" className="with-gap" name="payment_mode" checked={this.state.form1.payment_mode === "cb_only"} onChange={this.handlePaymentMode.bind(this, "cb_only")} /> <span>CB obligatoire (100% des paiements in-app)</span>
										</label>
									</React.Fragment>
								)}
								<label>
									<p>Vue groupée :</p>
									<input type="checkbox" checked={this.state.form1.list_mode} onChange={this.handleListMode} /><span></span>
								</label>
								<label>
									<p className="error">{this.state.error.cover}</p>
									<p className="column-20">Photo de couverture :</p>
									<input type="file" onChange={this.handleCover} />
								</label>
								{prev}
								<p className="error">{this.state.error.service}</p>
								{sendbtn}
							</form>
						</div>
					</div>
					{detailsJSX /* Expanded parameters for service */}
					{deletebtn}
				</div>
			)
		}
		return (
			<div>
				<div className="wrapper-content">
					<Modal
						dismissible={false}
						content={this.state.modal_msg}
						open_modal={this.state.open_modal}
						answerModal={this.state.answerModal}
					/>
					<BannerInfo
						content={this.state.banner_content}
						show={this.state.show_banner}
						closeBanner={this.closeBanner}
						error={this.state.error.global}
						success={this.state.success}
					/>
					{content}
				</div>
			</div>
		)
	}
}

export default Services
